import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'src/hooks';
import { setShowCvPreview } from 'src/store/reducers/templates.reducer';

const Sidebar = ({ step }) => {
  const { id, preview } = useSelector((state) => state.templatesReducer.currentResume);
  const dispatch = useDispatch();
  const { translate } = useTranslation();
  const getProcent = () => {
    if (step) {
      if (step !== 1) {
        return (step / 7) * 100;
      }

      return 10;
    }
    return 10;
  };

  const handleShowCv = () => {
    dispatch(setShowCvPreview(true));
  };

  return (
    <div className="create__left">
      <div className="sidebar">
        <nav className="create__nav">
          <ul>
            <li>
              <NavLink to={`/my-cv/create/?id=${id}`} end className="create__nav__link">
                <span>1</span>
                {translate('cv_create.contact_information')}
              </NavLink>
            </li>
            <li>
              {id ? (
                <NavLink to={`/my-cv/create/work/?id=${id}`} className="create__nav__link">
                  <span>2</span>
                  {translate('cv_create.work_experience')}
                </NavLink>
              ) : (
                <div className="create__nav__link">
                  <span>2</span>
                  {translate('cv_create.work_experience')}
                </div>
              )}
            </li>
            <li>
              {id ? (
                <NavLink to={`/my-cv/create/hobbies/?id=${id}`} className="create__nav__link">
                  <span>3</span>
                  Hobbies
                </NavLink>
              ) : (
                <div className="create__nav__link">
                  <span>3</span>
                  Hobbies
                </div>
              )}
            </li>
            <li>
              {id ? (
                <NavLink to={`/my-cv/create/education/?id=${id}`} className="create__nav__link">
                  <span>4</span>
                  {translate('cv_create.education')}
                </NavLink>
              ) : (
                <div className="create__nav__link">
                  <span>4</span>
                  {translate('cv_create.education')}
                </div>
              )}
            </li>
            <li>
              {id ? (
                <NavLink
                  to={`/my-cv/create/certifications/?id=${id}`}
                  className="create__nav__link "
                >
                  <span>5</span>
                  {translate('cv_create.certifications')}
                </NavLink>
              ) : (
                <div className="create__nav__link">
                  <span>5</span>
                  {translate('cv_create.certifications')}
                </div>
              )}
            </li>
            <li>
              {id ? (
                <NavLink to={`/my-cv/create/skills/?id=${id}`} className="create__nav__link">
                  <span>6</span>
                  {translate('cv_create.skills')}
                </NavLink>
              ) : (
                <div className="create__nav__link">
                  <span>6</span>
                  {translate('cv_create.skills')}
                </div>
              )}
            </li>
            <li>
              {id ? (
                <NavLink to={`/my-cv/create/languages/?id=${id}`} className="create__nav__link">
                  <span>7</span>
                  {translate('cv_create.languages')}
                </NavLink>
              ) : (
                <div className="create__nav__link">
                  <span>7</span>
                  {translate('cv_create.languages')}
                </div>
              )}
            </li>
          </ul>
        </nav>
        {preview && (
          <div className="create__preview">
            <div className="create__t">{translate('cover_create.preview')}</div>

            <div className="create__preview__img">
              <img src={preview} alt="" />
              <button type="button" className="btn btn-primary" onClick={handleShowCv}>
                Preview
              </button>
            </div>
          </div>
        )}

        <div className="create__progress">
          <div className="create__t">{translate('cover_create.progress')}</div>
          <div className="create__progress__line">
            <div className="create__progress__percent" style={{ width: `${getProcent()}%` }} />
          </div>
        </div>
      </div>
    </div>
  );
};
Sidebar.propTypes = {
  step: PropTypes.number.isRequired,
};
export default Sidebar;
